"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureSettle = configureSettle;
exports.listBillStatsPaged = listBillStatsPaged;
var _request = _interopRequireDefault(require("@/utils/request"));
// 提现列表
function listBillStatsPaged(params) {
  return (0, _request.default)({
    url: '/portal/system/settle/listBillStatsPaged',
    method: 'get',
    params: params
  });
}
function configureSettle(data) {
  return (0, _request.default)({
    url: '/portal/system/settle/configureSettle',
    method: 'post',
    data: data
  });
}